module.exports = __webpack_public_path__ + "static/img/application_img4.efe8dc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application_img4.jpg
// module id = ZcJh
// module chunks = 0